<div class="col-md-12 mb-30">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0">Behfa Equipment Check-in/Check-out</h5>
      <br />

      <br>
      <br>


      <div class="row">
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1"> Status </label>
          <select class="custom-select" [(ngModel)]="Filter_Type_Lap" >
            <option value="1">Checked Out but Not Checked In (No Date Filter) </option>
            <option value="2">Checked Out but Not Checked In (by Reception Date) </option>
            <option value="3">Checked Out and Returned (by Reception Date)</option>
            <option value="4">Checked Out and Returned (by Delivery Date)</option>
          </select>
        </div>

        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Reception Date Start</label>
          <input type="text" #datepickerInputStart placeholder="Type here..."   class="form-control" />
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false" [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputStart"></ng-persian-datepicker>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Reception Date End</label>
          <input type="text" #datepickerInputEnd  placeholder="Type here..."  class="form-control" />
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false" [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputEnd"></ng-persian-datepicker>
        </div>

        <div class="form-group col-md-3">
          <label for="exampleInputEmail1"> Code BEHFA</label>
          <input [(ngModel)]="Filter_Code"  name="Filter_Code" type="text"
            class="form-control" placeholder="Type here to search...">
        </div>
      </div>

      <div class="row">

        <div class="form-group col-md-9">
          <button *ngIf="!Procssing" type="button" (click)="ReadData_DeviceBehfa(datepickerInputStart.value,datepickerInputEnd.value)" class="btn btn-info"
            style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>

            <button *ngIf="!Procssing" type="button" routerLink="/DeviceBehfaDownloadForm" class="btn btn-success"
            style="margin-right: 5px;"><i class="fa  fa-cloud-upload"></i> Check Out Behfa Equipment </button>

          <button *ngIf="!Procssing" type="button" routerLink="/DeviceBehfaUploadForm" class="btn btn-warning"
            style="margin-right: 5px;"><i class="fa  fa-cloud-download"></i> Check In Behfa Equipment </button>

            <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
        </div>





        <div class="form-group col-md-3">
          <label for="exampleInputEmail1"> Calibration Technician </label>
          <app-ExpertCalibrationOption
          (OnBack_ExpertCalibration_Action)="OnGet_ExpertCalibration_Action($event)">

          </app-ExpertCalibrationOption>
        </div>

      </div>



      <br>
      <br>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Description</th>
              <th>Code BEHFA</th>
              <th>Name User</th>
              <th>Reception Date</th>
              <th>Exit Reason</th>
              <th>Delivery Date</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_DeviceBehfa
            | paginate
                    : {
                        id: 'DataList_DeviceBehfaTable',
                        itemsPerPage: 50,
                        currentPage: page,
                        totalItems: (DataList_DeviceBehfa).length
                      }
            ">
              <td>{{DataList_DeviceBehfa.indexOf(item)+1}}</td>
              <td class="EnglishClm">{{item.description}}</td>
              <td class="EnglishClm">{{item.codeBEHFA}}</td>
              <td>{{item.username}}</td>
              <td>{{item.downloadDate}}</td>
              <td>{{item.downloadType}}</td>
              <td>{{item.uploadDate}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <pagination-controls id="DataList_DeviceBehfaTable" nextLabel="Next" previousLabel="Previous"
      (pageChange)="page = $event"></pagination-controls>
  </div>
</div>

<ng-template #templateUpload>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Check In Behfa Equipment </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Upload.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="card-body">
    <div class="row">

      <div class="form-group col-md-12">
        <label for="exampleInputEmail1"> Click the field below before scanning the QR code. <i class="fa fa-arrow-down"></i>
        </label>
        <input [(ngModel)]="QRCodeInput" name="QRCodeInput" type="text"
          style="font-family: Arial, Helvetica, sans-serif;background-color: #dfdddd;" class="form-control EnglishClm"
          placeholder="Click here...">
      </div>
    </div>
    <div class="row" *ngIf="Info_Upload_List.length>0">
      <div class="form-group col-md-12">
        <div class="table-responsive">
          <table class="mb-0 table table-bordered table-3 text-center table-striped">
            <thead style="background-color: #489b39; color: white;">
              <tr>
                <th>#</th>
                <th>Equipment Code</th>
                <th>Equipment Serial Number</th>
                <th>QR Code</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of Info_Upload_List">
                <td>{{Info_Upload_List.indexOf(item)+1}}</td>
                <td>{{item.codeBEHFA}}</td>
                <td>{{item.codeBEHFA}}</td>
                <td>{{item.model}}</td>
                <td>
                  <button (click)="Info_Upload_Remove(Info_Upload_List.indexOf(item))" class="btn btn-danger"><i
                      class="fa fa-remove"></i> Delete </button>
                </td>

              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>


  </div>
  <div class="modal-footer">
    <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!InProccessing" (click)="QRCodeChangeUpload()" type="submit" [disabled]="Info_Upload_List.length==0"
      class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Save </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Upload.hide()">Close</button>
  </div>
</ng-template>
